import {
  OnboardingLivePlanIssueSeverity,
  OnboardingLiveSlotPlanItemFragment,
} from "../gql/graphql.ts";
import { classNames } from "../UI/Utils/classNames.ts";
import { describePlanIssue } from "./describePlanIssue.ts";
import { useOnboardingLiveConductors } from "./useOnboardingLiveConductors.ts";
import { useAllUserGroups } from "../UserGroup/useAllUserGroups.ts";

const severityClasses: Record<OnboardingLivePlanIssueSeverity, string> = {
  [OnboardingLivePlanIssueSeverity.Blocking]:
    "border-red-200 bg-red-50 text-red-800",
  [OnboardingLivePlanIssueSeverity.Warning]:
    "border-amber-200 bg-amber-50 text-amber-800",
  [OnboardingLivePlanIssueSeverity.Notice]:
    "border-sky-200 bg-sky-50 text-sky-800",
};

const severityLabels: Record<OnboardingLivePlanIssueSeverity, string> = {
  [OnboardingLivePlanIssueSeverity.Blocking]: "Bloccante",
  [OnboardingLivePlanIssueSeverity.Warning]: "Attenzione",
  [OnboardingLivePlanIssueSeverity.Notice]: "Info",
};

export function PlanIssueList({
  issues,
}: {
  issues: OnboardingLiveSlotPlanItemFragment["issues"];
}) {
  const { teacherNameOf } = useOnboardingLiveConductors();
  const { userGroups } = useAllUserGroups();
  const userGroupNameOf = (userGroupId: string) =>
    userGroups.find((g) => g.id === userGroupId)?.name ?? userGroupId;
  if (issues.length <= 0) return null;
  return (
    <ul className={"space-y-1"}>
      {issues.map((issue, index) => {
        const { text, suggestion } = describePlanIssue(issue, {
          teacherNameOf,
          userGroupNameOf,
        });
        return (
          <li
            key={`${issue.code}-${index}`}
            className={classNames(
              "rounded border px-2 py-1 text-xs",
              severityClasses[issue.severity],
            )}
          >
            <span className={"font-semibold"}>
              {severityLabels[issue.severity]}:
            </span>{" "}
            {text}
            {suggestion ? (
              <span className={"block opacity-80"}>→ {suggestion}</span>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
